let deviceId: string | null = null;

export const setDeviceId = (id: string | null) => {
  deviceId = id;
};

export const getDeviceId = (): string | null => {
  return deviceId;
};
